import React, { useReducer, useEffect } from 'react';
import { Form, Grid, Button, Input, Label, Checkbox, Icon, TextArea, Message, Container } from 'semantic-ui-react';
import svg_icon_path from "../../static/media/SVGSpriteIcon.svg";
import { formReducer, initialState } from './../../reducers/CCHiFirm/IntegrationFormReducer';
import { CPAUTILITIES } from "../../Constants/routes";
import {
  setFormData,
  togglePassword,
  setCanActivate,
  setCanSubmit,
  fetchFormData,
  submitForm,
  validateForm,
  setValidationErrors
} from './../../actions/cchiFirm/integrationFormActions';

const IntegrationForm = () => {
  const [state, dispatch] = useReducer(formReducer, initialState);

  useEffect(() => {
    fetchFormData(dispatch);
  }, []);

  useEffect(() => {
    const { apiKey, domainUrl } = state.formData;
    const fieldsHaveValue = apiKey.trim() !== '' && domainUrl.trim() !== '';
    const { isValid, errors } = validateForm(state.formData);
    
    dispatch(setCanActivate(fieldsHaveValue && isValid));
    dispatch(setCanSubmit(fieldsHaveValue && isValid));
    dispatch(setValidationErrors(errors));
  }, [state.formData]);

  const handleChange = (e, { name, value }) => {
    dispatch(setFormData({ [name]: value }));
  };  

  const handleTogglePassword = () => {
    dispatch(togglePassword());
  };

  const handleToggle = (e, { name, checked }) => {
    if (name === 'activateIntegration' && !state.canActivate) {
      return;
    }
    dispatch(setFormData({ [name]: checked }));
  };

  const handleCancel = (e) => {
    e.preventDefault();
    window.top.location.href = CPAUTILITIES;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (state.canSubmit) {
      await submitForm(dispatch, state.formData);
    }
  };

  return (
    <Container className='m-10'>
      <Form onSubmit={handleSubmit} loading={state.isLoading}>
      <Grid columns={2}>
        <Grid.Row className="mb-30 mt-30">
            <Grid.Column width={16}>
                <div className="ui info message p-16 d-flex" id="ifirminfo">
                    <div className="d-flex flex-grow-1">
                    <svg className={`svg_icon xcm-icon-alert-circle size-24 color-wk-primary-blue mr-4`}>
                        <title> CCH iFirm </title>
                        <use xlinkHref={`${svg_icon_path}#xcm-icon-alert-circle`}> </use>
                    </svg>
                    <span className="wk-font-size-16">
                        To be able to link an iFirm Taxprep tax return to a task sheet, check the "Activate Integration" checkbox
                        and enter the domain link as well as the key that is available in iFirm Taxprep Settings.
                    </span>
                    </div>
                </div>
            </Grid.Column>
        </Grid.Row>

        <Grid.Row className="mb-30">
        <Grid.Column width={4}>
            <Label className='bg-white border-0 bold'>Application Name:</Label>
        </Grid.Column>
        <Grid.Column width={12}>
            <Input
            fluid
            readOnly
            name="name"
            id="appname"
            value={state.formData.name}
            onChange={handleChange}
            style={{
              pointerEvents: 'none'
            }}
            />
        </Grid.Column>
        </Grid.Row>
          
        <Grid.Row className="mb-30">
        <Grid.Column width={4}>
            <Label className='bg-white border-0 bold'>Description:</Label>
        </Grid.Column>
        <Grid.Column width={12}>
            <TextArea
                rows={4}
                readOnly
                name="description"
                id="description"
                value={state.formData.description}
                onChange={handleChange}
                style={{
                  pointerEvents: 'none',
                  width: '100%'
                }}
                />
        </Grid.Column>
        </Grid.Row>

        <Grid.Row className="mb-30">
          <Grid.Column width={4}>
            <Label className='bg-white border-0 bold'>Domain:</Label>
          </Grid.Column>
          <Grid.Column width={12}>
            <Input
              fluid
              name="domainUrl"
              id="domainUrl"
              placeholder="Enter integration URL"
              value={state.formData.domainUrl}
              onChange={handleChange}
              error={!!state.validationErrors.domainUrl}
              autoComplete="new-password"
            />
            {state.validationErrors.domainUrl && (
              <Label basic color='red' pointing>
                {state.validationErrors.domainUrl}
              </Label>
            )}
          </Grid.Column>
        </Grid.Row>
              
        <Grid.Row className="mb-30">
          <Grid.Column width={4}>
            <Label className='bg-white border-0 bold'>Key:</Label>
          </Grid.Column>
          <Grid.Column width={12}>
            <Input
              fluid
              type={state.showPassword ? "text" : "password"}
              name="apiKey"
              id="apiKey"
              placeholder="Enter key"
              value={state.formData.apiKey}
              onChange={handleChange}
              autoComplete="new-password"
              icon={
                <Icon
                  name={state.showPassword ? "eye slash" : "eye"}
                  link
                  onClick={handleTogglePassword}
                />
              }
              error={!!state.validationErrors.apiKey}
            />
            {state.validationErrors.apiKey && (
              <Label basic color='red' pointing>
                {state.validationErrors.apiKey}
              </Label>
            )}
          </Grid.Column>
        </Grid.Row>

        <Grid.Row className="mb-30">
          <Grid.Column width={4}>
            <Label className='bg-white border-0 bold'>Activate Integration:</Label>
          </Grid.Column>
          <Grid.Column width={12}>
            <Checkbox
              toggle  
              name="isFirmIntegrationActive"
              id="isFirmIntegrationActiveToggle"
              checked={state.formData.isFirmIntegrationActive}
              onChange={handleToggle}
              disabled={!state.canActivate}
            />
          </Grid.Column>
        </Grid.Row>
      
        <Grid.Row>
          <Grid.Column className='m-10' width={16}>
            {state.apiMessage && (
              <Message
                id="validationMessage" 
                positive={state.apiMessage.includes('saved')} 
                negative={state.apiMessage.includes('trouble')}
              >
                {state.apiMessage}
              </Message>
            )}
            <Button
              id="back" 
              className='float-right ui button ml-24' 
              onClick={handleCancel}
              type="button"
            >
              {state.isSubmitted ? 'Back' : 'Cancel'}
            </Button>
            <Button
              id="submit" 
              className='ui primary float-right approve' 
              type="submit" 
              disabled={!state.canSubmit || state.isLoading}
            >
              {state.isLoading ? 'Submitting...' : 'Save'}
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
    </Container>
  );
};

export default IntegrationForm;